import type { ShopifyLinklistLink } from '../types/index.js'

export class ShopifyLinklistService {
  /**
   * Get the parent link of a link object by handle
   * @param handle The parent link object handle
   * @param type The object type you are looking for, can be undefined for all types
   */
  public static getParentLinkByHandle(
    handle: string,
    type?: 'collection_link' | 'page_link',
  ): ShopifyLinklistLink | undefined {
    if (!window.linklists?.categoryMenu?.links) {
      console.warn(
        new Error(
          `window.linklists.categoryMenu.links not set, please make sure this is defined in shopify/snippets/utils-global-javascript.liquid before you try access this!`,
        ),
      )
      return undefined
    }

    const links: ShopifyLinklistLink[] =
      window.linklists?.categoryMenu?.links || []

    for (const link1 of links) {
      if (type && link1?.type !== type) {
        continue
      }
      for (const link2 of link1.links) {
        if (type && link2?.type !== type) {
          continue
        }
        if (link2?.object?.handle === handle) {
          return link1
        }
        for (const link3 of link2.links) {
          if (type && link3?.type !== type) {
            continue
          }
          if (link3?.object?.handle === handle) {
            return link2
          }
        }
      }
    }

    return undefined
  }
}
